export function placesChanged(place) {
    const event = new CustomEvent("pos/places_changed", {detail: place});
    document.dispatchEvent(event);
}